import { render, staticRenderFns } from "./infiniteScroll.vue?vue&type=template&id=1c068ac0&scoped=true"
import script from "./infiniteScroll.vue?vue&type=script&lang=js"
export * from "./infiniteScroll.vue?vue&type=script&lang=js"
import style0 from "./infiniteScroll.vue?vue&type=style&index=0&id=1c068ac0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c068ac0",
  null
  
)

export default component.exports